import React from 'react';

import reports from '../../../../../images/reports.svg';

const ReportsIcon = ({ height = '14px', width = height, altText = 'icon', selected }) => {
  return <img src={reports} alt={altText} style={{ width, height }} />;
};

export default ReportsIcon;
